import React from "react";
import clsx from "clsx";
import { InstructorCard } from "@components/InstructorCard";
import { useSelector } from "react-redux";
import styles from "./style/HomeRightSidebar.module.css";
import { INSTRUCTOR_ROLE } from "@constants";
import { AccessControl } from "@components/AccessControl";
import { TopCategories } from "@components/TopCategories";

const HomeRightSidebar = () => {
  // state

  // variables

  // logics before hooks

  // hooks
  const { profile } = useSelector((state) => state.user);

  // logics

  // UI partials

  // effects

  // render
  return (
    <div className={clsx(styles.rightSidebar, "d-flex flex-column")}>
      {profile.data && (
        <AccessControl targetRoles={[INSTRUCTOR_ROLE]}>
          <InstructorCard data={profile.data} />
        </AccessControl>
      )}
      <TopCategories />
    </div>
  );
};

/* required: display name */
HomeRightSidebar.displayName = "HomeRightSidebar";

/* required: props types */
HomeRightSidebar.propTypes = {};

/* required: default props */
HomeRightSidebar.defaultProps = {};

export { HomeRightSidebar };
